export const reportUnitsWithPermissionTypes = {
  SET_UNITS_WITH_PERMISSION_FILTERS: 'SET_UNITS_WITH_PERMISSION_FILTERS',
  RESTORE_INITIAL: 'REPORT_UNITS_WITH_PERMISSION/RESTORE_INITIAL'
};
